"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const router_1 = require("next/router");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_modals_1 = require("@hotelplan/components.common.modals");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const ErrorNotificationModal = (0, styled_components_1.default)(components_common_modals_1.NotificationModal)(({ theme }) => ({
    '.modal-wrapper': theme.modals.smallModalWrapper,
}));
const LoginErrorNotification = () => {
    const [t] = (0, next_i18next_1.useTranslation)(['myaccount']);
    const { query, pathname, asPath, replace } = (0, router_1.useRouter)();
    const hasError = `error` in query;
    const [isError, , hideError] = (0, libs_hooks_react_1.useToggleState)(hasError);
    const closeError = () => {
        hideError();
        const pathWithoutQueries = asPath.split('?')[0];
        replace(pathname, pathWithoutQueries, { scroll: false, shallow: true });
    };
    return (react_1.default.createElement(ErrorNotificationModal, { name: "loginError", title: "", show: isError, type: components_common_modals_1.NotificationType.ERROR, onClose: closeError }, t('myaccount:login.error')));
};
exports.default = LoginErrorNotification;
//# sourceMappingURL=LoginErrorNotification.js.map